import roleAccess from '../../assets/strings/roleAccess'
const state = {
  myUserInfo: null,
  fcmToken: null,
}

const getters = {
  role: state => state.myUserInfo && state.myUserInfo.role,
  isAllowed: (state, getters) => action => !!(roleAccess[getters.role] && roleAccess[getters.role].includes(action)),
  isActivated: state => state.myUserInfo && state.myUserInfo.activated,
}

const mutations = {
  set_my_user_info (store, data) {
    store.myUserInfo = data
  },
  reset_my_user_info (store) {
    store.myUserInfo = null
  },
  set_fcm_token (store, data) {
    store.fcmToken = data
  }
}

const actions = {
  async fetchMyInfo ({ commit, getters }) {
    let loadingInstance = this._vm.$loading({ fullscreen: true })
    try {
      const res = await this._vm.$_services.user.myInfo()
      console.log('TCL: fetchMyInfo -> res', res)
      commit('set_my_user_info', res.data)
      console.log('TCL: fetchMyInfo -> getters.isActivated', getters.isActivated)
      if (!getters.isActivated) {
        loadingInstance.close()
        commit('auth/logout', null, { root: true })
        this._vm.$message.error('Anda tidak punya akses untuk membuka halaman ini')
        throw new Error('not allowed')
      }
      if (getters.isAllowed('WEB_ACCESS')) {
        loadingInstance.close()
        return res
      } else {
        loadingInstance.close()
        commit('auth/logout', null, { root: true })
        this._vm.$message.error('Anda tidak punya akses untuk membuka halaman ini')
        throw new Error('not allowed')
      }
    } catch (error) {
      loadingInstance.close()
      return Promise.reject(error)
    }
  },
  async fetchFcmToken ({ commit, getters }) {
    let loadingInstance = this._vm.$loading({ fullscreen: true })
    try {
      const fcmToken = await this._vm.$_services.notifications.fetchFcmToken()
      if (fcmToken) {
        console.log('TCL: fetchFcmToken -> fcmToken', fcmToken)
        commit('set_fcm_token', fcmToken)
        loadingInstance.close()
        return fcmToken
      }
    } catch (error) {
      loadingInstance.close()
      return Promise.reject(error)
    }
  }
}

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
}
